import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { SpinningLoader } from '@frontend/design-system';
import { useAuth } from '../../providers/auth.provider';
import { createFileRoute } from '../../utils/route-factory';

function Logout() {
  useAuth().logout();

  return (
    <div
      css={css`
        align-items: center;
        display: flex;
        flex: 1;
        background-color: ${theme.colors.neutral5};
        justify-content: center;
        flex-direction: column;
        min-height: 100vh;
      `}
    >
      <SpinningLoader />
      Signing out. . .
    </div>
  );
}

export const Route = createFileRoute({ path: '/logout/', component: Logout, type: 'public' });
